"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bathroom = void 0;
const React = __importStar(require("react"));
const accordion_1 = require("../../../components/accordion");
const Chip_1 = require("../../../components/chip/Chip");
const RadioQuestion_1 = require("../../../components/input/radio/RadioQuestion");
const Spacer_1 = require("../../../components/spacer/Spacer");
const Bathroom = (props) => {
    const { bathroom, bathroomNumber, update } = props;
    return React.createElement(accordion_1.Accordion, { persistenceId: `tn-accordion-bathroom-${bathroom.id}`, id: `bathroom-${bathroomNumber}-accordion` },
        React.createElement(accordion_1.AccordionHeader, null,
            React.createElement(accordion_1.DefaultAccordionHeading, { heading: `Bathroom ${bathroomNumber}` })),
        React.createElement(accordion_1.AccordionItem, { noBorder: true },
            React.createElement(Chip_1.ChipQuestion, { question: "Select the features which are available in this bathroom" },
                React.createElement(Chip_1.Chip, { id: "toilet-chip", text: "Toilet and Sink", onChange: (_, selected) => update(Object.assign(Object.assign({}, bathroom), { toilet_type: selected ? 'standard' : 'none' })), selected: bathroom.toilet_type === 'standard' }),
                React.createElement(Chip_1.Chip, { id: "bath-chip", text: "Bath", onChange: (_, selected) => {
                        update(Object.assign(Object.assign({}, bathroom), { bath_type: selected ? 'tub' : 'none', shower_type: selected ? bathroom.shower_type : 'none' }));
                    }, selected: bathroom.bath_type === 'tub' }),
                React.createElement(Chip_1.Chip, { id: "shower-chip", text: "Shower", onChange: (_, selected) => update(Object.assign(Object.assign({}, bathroom), { shower_type: selected ? 'walk in' : 'none' })), selected: bathroom.shower_type !== 'none' })),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            bathroom.shower_type !== 'none' && (React.createElement(RadioQuestion_1.RadioQuestion, { id: "shower-type-radio-questions", question: "What type of shower does this bathroom have?", onChange: (_, value) => {
                    update(Object.assign(Object.assign({}, bathroom), { shower_type: value, bath_type: value === 'over bath' ? 'tub' : bathroom.bath_type }));
                }, options: {
                    'A standalone shower': 'walk in',
                    'An over-bath shower': 'over bath'
                }, selected: bathroom.shower_type })),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(Chip_1.ChipQuestion, { question: "Select the bathroom type" },
                React.createElement(Chip_1.Chip, { id: "private-bathroom-chip", text: "Private", onChange: (_, selected) => update(Object.assign(Object.assign({}, bathroom), { private_access: selected })), selected: bathroom.private_access }),
                React.createElement(Chip_1.Chip, { id: "wheelchair-accessible-bathroom-chip", text: "Wheelchair accessible", onChange: (_, selected) => update(Object.assign(Object.assign({}, bathroom), { accessible: selected })), selected: bathroom.accessible }),
                React.createElement(Chip_1.Chip, { id: "ensuite-bathroom-chip", text: "Ensuite", onChange: (_, selected) => update(Object.assign(Object.assign({}, bathroom), { ensuite: selected })), selected: bathroom.ensuite })),
            React.createElement(Spacer_1.Spacer, { spacing: "large" })));
};
exports.Bathroom = Bathroom;
//# sourceMappingURL=Bathroom.js.map